export const DND_TYPE = 'category_dnd';
